import { apiClient } from './api'
import type { EntityType } from './comments'

export interface Attachment {
  id: number
  entity_type: EntityType | null
  entity_id: number | null
  task_id: number | null
  version: number
  version_group_id?: string | null
  file_name: string
  file_size: number
  mime_type?: string | null
  checksum?: string | null
  storage_provider?: string | null
  storage_url?: string | null
  purpose?: string | null
  uploaded_by: number
  created_at: string
  deleted_at?: string | null
}

export interface UploadOptions {
  entityType: EntityType
  entityId: number
  file: File
  purpose?: string
  replacesId?: number
}

export const attachmentsService = {
  list: async (entityType: EntityType, entityId: number): Promise<Attachment[]> => {
    const { data } = await apiClient.get('/api/v1/attachments/', {
      params: { entity_type: entityType, entity_id: entityId },
    })
    return data
  },

  upload: async (opts: UploadOptions) => {
    const form = new FormData()
    form.append('file', opts.file)
    form.append('entity_type', opts.entityType)
    form.append('entity_id', String(opts.entityId))
    if (opts.purpose) form.append('purpose', opts.purpose)
    if (opts.replacesId) form.append('replaces_id', String(opts.replacesId))
    const { data } = await apiClient.post('/api/v1/attachments/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return data as {
      id: number
      file_name: string
      file_size: number
      s3_url: string | null
      created_at: string
    }
  },

  downloadUrl: async (id: number): Promise<string> => {
    const { data } = await apiClient.get(`/api/v1/attachments/${id}/download`)
    return data.download_url
  },

  versions: async (id: number): Promise<Attachment[]> => {
    const { data } = await apiClient.get(`/api/v1/attachments/${id}/versions`)
    return data
  },

  remove: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/v1/attachments/${id}`)
  },

  restore: async (id: number): Promise<Attachment> => {
    const { data } = await apiClient.post(`/api/v1/attachments/${id}/restore`)
    return data
  },
}
